import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-desk-schedule',
  templateUrl: './turns-desk-schedule.component.html',
  styleUrls: ['./turns-desk-schedule.component.scss']
})
export class TurnsDeskScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
